module.exports = __webpack_public_path__ + "static/img/aqzs44.4b8fa2b6.jpg";